import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SelectionTab from '../../../../../../components/ZUILib/SelectionTab';
import CheckBox from '../../../../../../components/ZUILib/CheckBox';
import Favourite from '../../../../../../components/ZUILib/Favourite';
import Image from '../../../../../../components/ZUILib/Image/Image';
import SelectionTabMore from '../../../../../../components/ZUILib/SelectionTabMore';
// import Warning from '../../../../../../components/Warning';
import Link from '../../../../../../components/ZUILib/Link';
// import Warning from '../../../../../../components/Warning';
import * as giftListActions from '../../actions';
import * as defaultConst from '../../../../../../utils/clientConstant';
import commonUtil from '../../../../../../utils/commonUtil';
import serverClientUtil from '../../../../../../utils/serverClientUtil';
import TextInput from '../../../../../../components/ZUILib/TextInput/TextInput';

import GiftModal from '../../../../../../components/GiftListModal';

const { setFavouriteGift, saveQuantity, handleChangeDeliveryAddress, changeDeliveryAddress, handleChangeDeliveryMode, changeDeliveryMode } = giftListActions;
const predefinedStatus = defaultConst.RESTRICTED_EVENT_STATUSES;

const eventTypes = [defaultConst.eventType.Bar_Mitzvah, defaultConst.eventType.Bat_Mitzvah, defaultConst.eventType.Baptism, defaultConst.eventType.First_Communion, defaultConst.eventType.Confirmacion, defaultConst.eventType.Other_Religious_Ceremonies, defaultConst.eventType.XV_Anos, defaultConst.eventType.Fiesta_Infantil];
class Template1 extends React.Component {
  constructor(props) {
    super(props);
    this.warningMessage = null;
  }
  sortType = {};
  electronicGifts = [];

  defaultImage = commonUtil.getAssetURL() + '/images/guest/no-image.png';

  shouldComponentUpdate() {
    if (this.props.isShowAll) {
      return false;
    }
    return true;
  }
  showButtons = (checkedID, giftDetail, checkStatus) => {
    if (checkStatus) {
      this.props.handleGiftSelection(giftDetail);
    } else {
      this.props.handleGiftUnselect(giftDetail);
    }
  }
  // setFavouriteGift = (e, item, handleChange) => {
  setFavouriteGift = (e, item) => {
    setFavouriteGift(this.props.eventId, item.giftItemId, item.skuId, (!item.isFavourite).toString()).then((response) => {
      if (response.body.status?.status === 'success') {
        this.props.updateGiftList(item.giftItemId, item.skuId, !item.isFavourite, item.quantity);
        this.props.updateRegisteredGift({ giftItemId: item.giftItemId, isFavourite: !item.isFavourite });
         this.props.getPaginatedRegisteredGifts({
          priceOrder: 'Ascending',
        });
      }
    }).catch((err) => { console.log(err); }); // console required
  }
  changeDeliveryAddressSingleProduct = (event, skuId, giftItemId) => {
    let changeAddressGiftItems = [];
    changeAddressGiftItems.push(giftItemId);
    // handleChangeDeliveryAddress(this.props.eventId, changeAddressGiftItems, (event.deliveryAddressId ? event.deliveryAddressId : 'noCelebratedOwner')).then(
    handleChangeDeliveryAddress(this.props.eventId, changeAddressGiftItems, event.deliveryAddressId).then((response) => {
      // handleChangeDeliveryAddress(this.props.eventId, changeAddressGiftItems, '4585').then((response) => {
      if (response.body.status?.success === 'success') {
        changeAddressGiftItems = [];
        this.props.makeIsChangeFalse();
        this.props.handleBulkAction(response.body.categoryItemsInfo, 'addressChange');
        const itemsInfo = response.body.categoryItemsInfo
          .map(cif => cif.itemInfo)
          .reduce((acc, curr) => [...acc, ...curr], []);
        itemsInfo.forEach(itemInfo => this.props.updateRegisteredGift(itemInfo));
      }
    }).catch((e) => { console.log(e); }); // console required
  }

  checkModeOfDelivery = (event, skuId, giftItemId, electronicGifts) => {
    let changeMoodeGiftItems = '';
    let giftItemIdArray = [];
    if (this.electronicGifts.length) {
      for (let i = 0; i <= electronicGifts.length; i++) {
        if (giftItemId === electronicGifts[i]) {
          break;
        } else if (i === electronicGifts.length - 1) {
          giftItemIdArray.push(giftItemId);
        }
      }
    } else {
      giftItemIdArray.push(giftItemId);
    }
    if (event.value === commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.physical.label')) {
      changeMoodeGiftItems = defaultConst.constGiftDeliveryMode.Físicos;
    } else {
      changeMoodeGiftItems = defaultConst.constGiftDeliveryMode.Electrónicos;
    }

    handleChangeDeliveryMode(this.props.eventId, giftItemIdArray, '', [], changeMoodeGiftItems).then((response) => {
      if (response.body.status?.status === 'success') {
        giftItemIdArray = [];
        this.props.makeIsChangeFalse();
        this.props.handleBulkAction(response.body.categoryItemsInfo, 'modeChange');
        const itemsInfo = response.body.categoryItemsInfo
          .map(cif => cif.itemInfo)
          .reduce((acc, curr) => [...acc, ...curr], []);
        itemsInfo.forEach(itemInfo => this.props.updateRegisteredGift(itemInfo));
      }
    }).catch((e) => { console.log(e); }); // console required
  }
  sortGiftList = (e, categoryName) => {
    this.sortType[categoryName] = (this.sortType[categoryName] === 'Descending') ? 'Ascending' : 'Descending';
    this.props.handleSortAndFilter(this.sortType[categoryName], '', categoryName);
    this.props.makeIsChangeFalse();
  }
  selectQuantity = (val, updateValue, data) => {
    const quantity = val.value;
    saveQuantity(this.props.eventId, data.giftItemId, data.skuId, quantity).then((response) => {
      if (response.body.status === 'success') {
        this.props.makeIsChangeFalse();
        this.props.updateGiftList(data.giftItemId, data.skuId, data.isFavourite, quantity);
        this.props.updateRegisteredGift({ giftItemId: data.giftItemId, quantity });
      } else { // if (response.body.status.status === 'failure')
        updateValue(val.orgValue);
      }
    }).catch(() => { updateValue(val.orgValue); });
  }
  isNotEmpty = obj => obj !== undefined && JSON.stringify(obj) !== JSON.stringify({})

    handleOpenModal = (giftDetails) => {
    this.giftModal.handleShow(giftDetails, this.props.registeredGiftList.deliveryAddressInfo);
  };

  handleGiftUpdate = (updatedGiftData) => {
    this.props.updateGiftList(
      updatedGiftData.giftItemId, 
      updatedGiftData.skuId, 
      updatedGiftData.isFavourite, 
      updatedGiftData.quantity
    );

    this.props.updateRegisteredGift({
      giftItemId: updatedGiftData.giftItemId,
      quantity: updatedGiftData.quantity,
      isFavourite: updatedGiftData.isFavourite,
      addressId: updatedGiftData.addressId,
      deliveryMode: updatedGiftData.deliveryMode
    });

    this.props.getPaginatedRegisteredGifts({
           priceOrder: 'Ascending',
        });
  }

  handleGiftDelete = () => {
    this.props.getPaginatedRegisteredGifts({
      priceOrder: 'Ascending',
    });
  }

  render() {
     const { registeredGifts = [], tableHeader } = this.props;
    //const { registeredGifts = [], tableHeader, activeCategory, registeredGiftList } = this.props;

   /*  let filteredGifts = registeredGifts;
    if(activeCategory){
      filteredGifts = registeredGiftList.categoryItemsInfo.filter(category => category.categoryName === activeCategory)
    }
    
    if(activeCategory){
      filteredGifts = filteredGifts[0]?.itemInfo || [];
    } */

    const {
      itemsCount: totalRegisteredGifts,
      certificateItemsInfo: registeredGiftCertificates = [],
      priceOrder = 'Ascending',
    } = this.props.originalRegisteredGiftList;

    const lables = this.props.lables;
    let isDisabled = false;
    if (this.props.compareEventStatus(this.props.eventStatus, predefinedStatus)) {
      isDisabled = true;
    }

    const giftListRow = (giftDetails, index) => {
      const categoryName = giftDetails.categoryName;
      const SelectionOptionsNumber = {
        id: 'number',
        disable: false,
        defaultValue: giftDetails.quantity,
        optionText: 'labelResourceId',
        optionValue: 'value',
        options: [{
          id: '1',
          value: '1',
          labelResourceId: '1',
          disabled: false,
        }, {
          id: '2',
          value: '2',
          labelResourceId: '2',
          disabled: false,
        }, {
          id: '3',
          value: '3',
          labelResourceId: '3',
          disabled: false,
        }, {
          id: '4',
          value: '4',
          labelResourceId: '4',
          disabled: false,
        }, {
          id: '5',
          value: '5',
          labelResourceId: '5',
          disabled: false,
        }, {
          id: 'more',
          value: 'Más',
          labelResourceId: 'Más',
          disabled: false,
        }],
      };
      let selectedDeliveryMode = commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.physical.label');
      if (giftDetails.deliveryMode === defaultConst.constGiftDeliveryMode.Físicos) {
        selectedDeliveryMode = commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.physical.label');
      } else selectedDeliveryMode = commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.electronic.label');

      const ModeOfDelivery = {
        htlmId: 'chooseParent',
        disable: false,
        defaultValue: selectedDeliveryMode,
        options: [{
          htmlId: defaultConst.constGiftDeliveryMode.Físicos, // fisico
          value: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.physical.label'),
          labelResourceId: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.physical.label'),
        }, {
          htmlId: defaultConst.constGiftDeliveryMode.Electrónicos, // Electrónico
          value: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.deliveryaddress.dropdown.electronic.label'),
          labelResourceId: 'Electrónicos',
        }],
      };
      const _imgsrc1 = [
        {
          media: '(max-width: 465px)',
          srcSet: giftDetails.imageURL, // || commonUtil.getAssetURL() + '/images/guest/no-image.png',
        },
      ];
      if (categoryName === 'Gift Certificate' || categoryName === 'Certificado Electrónico') {
        this.defaultImage = commonUtil.getAssetURL() + '/images/certificado.jpg';
      } else {
        this.defaultImage = commonUtil.getAssetURL() + '/images/guest/no-image.png';
      }
      const imageAttr1 = {
        id: 'img1',
        alt: 'Liverpool',
        src: giftDetails.imageURL,
        altImg: giftDetails?.altImageUrl || this.defaultImage, // this.defaultImage, // TODO: Need to upload all images in static asset
        pictureHtmlStyle: {
          maxHeightPicture: '105px',
        },
        className: 'giftImgHeight',
      };
      const giftSalePrice = commonUtil.getCurrency(giftDetails.salePrice ,  true);
      const [giftSalePriceWhole, giftSalePricecents] = giftSalePrice?.split('.') ?? ['', ''];
      const giftSalePriceFormatted = (
        <>
         <div className='gift-sale-price-format-container'>{giftSalePriceWhole}<sup>{giftSalePricecents}</sup></div>
        </>
      );

      const giftListPrice = commonUtil.getCurrency(giftDetails.listPrice ,  true);
       const [giftListPriceWhole, giftListPricecents] = giftListPrice?.split('.') ?? ['', ''];
      const [currencySymbol, priceValue] = giftListPriceWhole.split(' ').map(part => part.trim());
      const giftListPriceFormattedStrikeThrough = (
        <>
          <span className="textPriceBefore">{currencySymbol}</span> <span className="textPriceBefore">{priceValue}</span> <sup className="textPriceBefore priceBefore">{giftListPricecents}</sup>
        </>
      );
       const giftListPriceFormatted = (
        <>
         {giftListPriceWhole}<sup>{giftListPricecents}</sup>
        </>
      );


      const deliveryAddressName =
        (this.props.registeredGiftList?.deliveryAddressInfo.filter(
          (p1) => p1.deliveryAddressId === giftDetails.addressId,
        ) || [])[0]
          ? this.props.registeredGiftList.deliveryAddressInfo.filter(
              (p1) => p1.deliveryAddressId === giftDetails.addressId,
            )
          : this.props.registeredGiftList?.deliveryAddressInfo?.[0]
                ?.deliveryAddressId
            ? [this.props.registeredGiftList.deliveryAddressInfo[0]]
            : [];


      const isChecked = this.props.selectedGift.filter(itm => itm.giftItemId === giftDetails.giftItemId).length;
      return (
        <tr key={index} className='giftrowLines'>
          {this.props.compareEventStatus(this.props.eventStatus, defaultConst.eventStatus.VALIDITY_OFF_ACTIVE) || this.props.compareEventStatus(this.props.eventStatus, defaultConst.eventStatus.CLOSED) ? null :
            <td>
              <CheckBox id={'check_' + giftDetails.giftItemId} checked={isChecked} name="checkboxGift" getSelectedValue={(e) => { this.showButtons(('check_' + giftDetails.giftItemId), giftDetails, e.checked); }} disabled={isDisabled} />
            </td>}
          {/* <td className="text-center pl-1 favouriteGift" >
            {isDisabled ? <Favourite
              id={giftDetails.skuId}
              disabled="true"
              item={giftDetails}
              checked={giftDetails.isFavourite}
              tooltipData={<span className="tooltip-box w2 text-align-center">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.favorite.tooltip')}</span>}
            /> : <Favourite
              id={giftDetails.skuId}
              item={giftDetails}
              onchange={e => this.setFavouriteGift(e, giftDetails)} checked={giftDetails.isFavourite}
              tooltipData={<span className="tooltip-box w2 text-align-center">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.favorite.tooltip')}</span>}
            />
            }
          </td> */}
          {(categoryName === 'Gift Certificate' || categoryName === 'Certificado Electrónico') ?
            <td className="imgInner"> <Image imageAttr={imageAttr1} _imgsrc={_imgsrc1} /></td>
            :
            <React.Fragment>
              {(giftDetails.catalogRedirectionURL && (this.props.compareEventStatus(this.props.eventStatus, defaultConst.eventStatus.ADMINISTRATIVE_PROCESS) || this.props.compareEventStatus(this.props.eventStatus, defaultConst.eventStatus.VALIDITY_OFF_ACTIVE) || this.props.compareEventStatus(this.props.eventStatus, defaultConst.eventStatus.ACTIVE))) ?

                <td className={`${giftDetails.availability ? '' : 'item-notAvailable'} imgInner`}>
                  <a href={serverClientUtil.getLPURL() + giftDetails.catalogRedirectionURL} target="_blank" rel="noopener noreferrer">
                    {
                      giftDetails.availability ? 
                      <Image imageAttr={imageAttr1} _imgsrc={_imgsrc1} />
                      :
                      <React.Fragment>
                        <Image imageAttr={imageAttr1} _imgsrc={_imgsrc1} />
                        <span>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.item.notAvailable')}</span>
                      </React.Fragment>
                    }
                  </a>
                </td> :
                <td className={`${giftDetails.availability ? '' : 'item-notAvailable'} imgInner`}>
                {
                  giftDetails.availability ? 
                  <Image imageAttr={imageAttr1} _imgsrc={_imgsrc1} />
                  :
                  <React.Fragment>
                    <Image imageAttr={imageAttr1} _imgsrc={_imgsrc1} />
                    <span>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.item.notAvailable')}</span>
                  </React.Fragment>
                }
                </td>
              }
            </React.Fragment>
          }


          <td className="textToLeft articleInner 3">
            <div className="fontWeight400-fontSize16">{giftDetails.desc}</div>
            <div className="sku"><b>{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.sku.label')}:</b> <span className='giftlist-skuId'>{giftDetails.skuId}</span> </div>
          </td>
          <td className="priceAndQuant priceInner">
            {giftDetails.salePrice && giftDetails.salePrice !== '' &&  parseFloat(giftDetails.salePrice) < parseFloat(giftDetails.listPrice) ? <div className='strike-price-container'><div className='strike-through-price'>{giftListPriceFormattedStrikeThrough}</div>
              <div className='gift-sale-price-container'>{giftSalePriceFormatted}</div></div> : <div className='gift-sale-price-container'>{giftListPriceFormatted}</div>}
          </td>
          <td className="priceAndQuant quantityInnerEG padtop20">
            <TextInput className="inputMaterial newInput gift-mode" value={giftDetails.quantity} disabled={true} />
            {/* {(isDisabled || categoryName === 'Gift Certificate' || categoryName === 'Certificado Electrónico') ? <TextInput className="inputMaterial newInput gift-mode" value={giftDetails.quantity} disabled={true} /> : <SelectionTabMore htmlId={'quantity_' + giftDetails.giftItemId} data={giftDetails} selectMoreOptions={SelectionOptionsNumber} handleSelectedOption={this.selectQuantity} />} */}
          </td>

          {/* {giftDetails.availability === 'true' ?
            <td className="priceAndQuant disponibilityInner disponible">
              <React.Fragment>
                <div className="tooltip-container">
                  <span className="textGreen">{commonUtil.getLabel(lables.RegalosRegistradosPage, 'regalosregistrados.inventory.displonsible.label')}</span>&nbsp;&nbsp;
                  <span className="tooltip-box">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.item.available.tooltip')}</span>
                </div>
              </React.Fragment>
            </td>
            :
            <td className="priceAndQuant disponibilityInner">
              <React.Fragment><div className="tooltip-container">
                <span className="textRed">{commonUtil.getLabel(lables.RegalosRegistradosPage, 'regalosregistrados.inventory.nodisplonsible.label')}</span>&nbsp;&nbsp;
                <span className="tooltip-box">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.item.available.online.tooltip')}</span>
              </div>
              </React.Fragment>
            </td>} */}

          <td className="text-center addressInner padtop20">
            {giftDetails.deliveryMode === defaultConst.constGiftDeliveryMode.Físicos ? // fisico  // Checking deliveryMode === physical
               <React.Fragment>
                {
                  deliveryAddressName && deliveryAddressName[0]?.deliveryAddressName ? <TextInput className="inputMaterial newInput gift-mode" value={deliveryAddressName[0].deliveryAddressName} disabled={true} /> : ""
                }
                  </React.Fragment> :  // Checking deliveryMode !== physical
              ''
            }
          </td>
          <td className="deliverymode padtop20">
            <React.Fragment>{giftDetails.deliveryMode === defaultConst.constGiftDeliveryMode.Físicos ? <TextInput className="inputMaterial newInput gift-mode" value={commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.physical.label')} disabled={true} /> : <TextInput className="inputMaterial newInput gift-mode" value={commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.electronic.label')} disabled={true} />}</React.Fragment>
          </td>
          <td className="text-center pl-1 favouriteGift" >
            <div>
            <div>
            {isDisabled ? <Favourite
              id={giftDetails.skuId}
              disabled="true"
              item={giftDetails}
              checked={giftDetails.isFavourite}
              display = 'icons'
              tooltipData={<span className="tooltip-box w2 text-align-center">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.favorite.tooltip')}</span>}
            /> : <Favourite
              id={giftDetails.skuId}
              item={giftDetails}
              onchange={e => this.setFavouriteGift(e, giftDetails)} checked={giftDetails.isFavourite}
              tooltipData={<span className="tooltip-box w2 text-align-center">{commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.favorite.tooltip')}</span>}
              display = 'icons'
            />
            }
            </div>
            <div>
              {
                isDisabled  ? (
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" fill="none" style={{
                  cursor: "not-allowed",
                }}
                >
                  <path d="M1.70492 0.5L0.294922 1.91L4.87492 6.5L0.294922 11.09L1.70492 12.5L7.70492 6.5L1.70492 0.5Z" fill="#767676" />
                </svg>
                ):
                (
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13" fill="none" style={{
                  cursor: "pointer",
                }}
                  onClick={(e) => this.handleOpenModal(giftDetails)}>
                  <path d="M1.70492 0.5L0.294922 1.91L4.87492 6.5L0.294922 11.09L1.70492 12.5L7.70492 6.5L1.70492 0.5Z" fill="#767676" />
                </svg>
                )
              }
                <GiftModal ref={(modal) => (this.giftModal = modal)} title={giftDetails.desc} giftDetails={giftDetails}
                  onUpdate={this.handleGiftUpdate}
                  lables={lables}
                  deliveryAddressInfo ={this.props.registeredGiftList.deliveryAddressInfo}
                  ownerName={deliveryAddressName[0]?.deliveryAddressName ?? ''}
                  onDelete={this.handleGiftDelete}
                  deletePopup={this.props.deletePopup}
                  getPaginatedRegisteredGifts={this.props.getPaginatedRegisteredGifts}
                />
            </div>
            </div>
          </td>
          {/* <td className="text-center pl-1">
            <img
              src={
                commonUtil.getAssetURL() + "/images/chevron_right.svg"
              }
              alt=""
              style={{
                width: '24px',
                height: '24px'
              }}
            />
          </td> */}
        </tr >
      );
    };

    const linkJSON = {
      displayName: commonUtil.getLabel(lables.EventAdminPage, 'adminpage.regalosregistrados.desc.label'),
      areaLabel: 'Artículo',
      href: 'javascript:void(0);',
      class: 'linkClass',
    };
    const LinkJSONPrice = {
      href: 'javascript:void(0);',
      displayName: '',
      onClickHandler: () => {
        this.props.getPaginatedRegisteredGifts({
          priceOrder: priceOrder === 'Ascending' ? 'Descending' : 'Ascending',
        });
      },
    };
    return (
      <table className="tableRegisteredGifts certificadosDeRegalosTable">
          <tbody>
            {registeredGifts.map(giftListRow)}
          </tbody>
        </table>
    );
  }
}
const mapStateToProps = state => ({
  favouriteGift: state.giftList.data,
});
const matchDispatchToProps = dispatch => bindActionCreators(
  {
    changeDeliveryAddress,
    changeDeliveryMode,
  }, dispatch);
export default connect(mapStateToProps, matchDispatchToProps)(Template1);
